import { MouseEvent, useMemo } from 'react'
import { v4 as uuid } from 'uuid'

import { OpenFormProps } from '@pages/ConfiguredEntity/types'

import { useFetchParameterPropertiesQuery } from '@redux/api/parameters.api'
import { openViewDialog } from '@redux/reducers/dialogWindowManager.reducer'

import { useAppDispatch } from '@hooks'
import {
  checkMaxOpenedWindowsCount,
  getInitialPositionWindow,
  transformCommonParametersToValues,
} from '@helpers'
import { ACTION_CODE, COMMON_PARAMETERS } from '@constants'
import { ActionResultType, ActionRow, DIALOG_WINDOW_TYPE, ObjectDataValue } from '@types'

import { MuiEvent } from '../../../../wiskey-react-table-component/src'

export const useOpenView = () => {
  const dispatch = useAppDispatch()
  const { data: commonParameters } = useFetchParameterPropertiesQuery({
    code: COMMON_PARAMETERS.STATE,
  })

  const initialCommonParameters = useMemo(
    () => transformCommonParametersToValues(commonParameters),
    [commonParameters]
  )

  const openView = (
    action: ActionRow,
    srcObj: {
      formProps?: OpenFormProps
      event?: MouseEvent<HTMLButtonElement> | MuiEvent<MouseEvent>
      additionalProps?: {
        addHistory?: boolean
      }
    } = {}
  ) => {
    const { event } = srcObj

    if (!event || checkMaxOpenedWindowsCount(initialCommonParameters)) {
      return Promise.resolve({
        actionCode: ACTION_CODE.OPEN_VIEW,
        value: {
          opened: false,
          srcObj,
        },
      } as ActionResultType<Record<string, ObjectDataValue>>)
    }

    const initialPosition = getInitialPositionWindow(event)

    dispatch(
      openViewDialog({
        id: uuid(),
        type: DIALOG_WINDOW_TYPE.VIEW,
        title: action.title,
        parentDialogId: null,
        meta: {
          viewId: Number(action.viewId),
          viewCode: action.viewCode || null,
          title: action.title || '',
          path: action.viewId?.toString() || '',
        },
        initialPosition,
      })
    )

    return Promise.resolve({
      actionCode: ACTION_CODE.OPEN_VIEW,
      value: {
        opened: true,
        srcObj,
      },
    } as ActionResultType<Record<string, ObjectDataValue>>)
  }

  return {
    openView,
  }
}
